<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        درخواست انتقال به شماره
        <q-badge align="top" color="red" text-color="white"
                 :label="items && items.length>0 ?Math.abs(items[0].GoEvent_Num):''"/>
        <template v-slot:action>
          <q-btn icon="close" v-close-popup text-color="white" round flat/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-for="(item, index) in items" :key="index" class="no-padding">
      <q-btn icon="check" color="green" text-color="white" round size="sm"
             v-if="$store.state.roles.some(v=>['admin','can_accept_hava'].includes(v))"
             v-close-popup="items.length===0"
             @click="deleteItem(item)"/>
      {{ item.Goods_Name }}
      <q-badge color="indigo-10" text-color="white" :label="item.Goods_Code"/>
      <q-badge color="red" class="q-ml-xs" text-color="white"
               :label="item.GoEvent_StIn!==0?item.GoEvent_StIn:item.GoEvent_StOut"/>
      <q-space v-if="$q.screen.lt.md" />
      <q-chip :label="item.General_Name" square/>
      <q-separator spaced/>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "TransferRequestDetails",
  props: {
    items: {
      type: []
    }
  },
  data() {
    return {
      selectedType: {label: 'کل', value: -1},
      options: [
        {label: 'کل', value: -1},
        {label: 'کسر از انبار', value: 701},
        {label: 'اضافه به انبار', value: 702}
      ]
    }
  },
  methods: {
    ...mapActions({
      setCofirm: 'Products/setGoodsTransferRequestConfirm'
    }),
    deleteItem(item) {
      this.setCofirm({
        Goods_IDD: item.Goods_IDD,
        Goods_ID: item.Goods_ID
      }).then((res) => {
        if (res.result === 1) {
          this.$emit('deleted-item', item.Goods_IDD)
          const record = this.items.filter(record => record.Goods_IDD === item.Goods_IDD)
          if (this.items.length === 0) {
            this.$emit('close-dialog', record)
          }
          this.$q.notify({
            message: `تاییدیه صادر گردید`,
            color: 'positive',
            position: 'top',
            type: 'positive'
          });
        } else if (res.result === -1) {
          this.$q.notify({
            message: `به دلیل منفی شدن موجودی امکان تایید درخواست`,
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        } else if (res.result === -999999) {
          this.$q.notify({
            message: `به دلیل مسدود بودن امکان تایید درخواست`,
            color: 'negative',
            position: 'top',
            type: 'negative'
          });
        }
      })
    }
  },
}
</script>

<style scoped>

</style>